import { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import heroImg from '~/assets/screenshots/bridgeway-farm-demo.png'

export const ParallaxHero = ({ children, imgTop = '100%', scrollMultiplier = 1.25, contentSx, sx }) => {
  const [mounted, setMounted] = useState(false)
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY)
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => { setTimeout(() => setMounted(true), 50) }, [])

  return (
    <Box sx={{
      background: 'linear-gradient(135deg, #263d24 0%, #375934 50%, #5a7d56 100%)',
      color: '#fff',
      py: { xs: 8, md: 0 },
      px: { xs: 3, md: 8 },
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden',
      height: { md: 460 },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...sx,
    }}>
      <Box
        component="img"
        src={heroImg}
        alt=""
        aria-hidden
        sx={{
          position: 'absolute',
          top: imgTop,
          left: 0,
          width: '100%',
          height: '250%',
          objectFit: 'cover',
          objectPosition: 'center center',
          transform: `translateY(calc(-50% - ${scrollY * scrollMultiplier}px))`,
          opacity: 0.18,
          zIndex: 0,
        }}
      />
      <Box sx={{
        position: 'absolute',
        inset: 0,
        background: 'radial-gradient(ellipse at 60% 40%, rgba(255,255,255,0.06) 0%, transparent 70%)',
        pointerEvents: 'none',
        zIndex: 1,
      }} />
      <Box sx={{
        position: 'relative',
        zIndex: 2,
        width: '100%',
        opacity: mounted ? 1 : 0,
        transform: mounted ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.7s ease, transform 0.7s ease',
        ...contentSx,
      }}>
        {children}
      </Box>
    </Box>
  )
}
